export default __webpack_public_path__ + "static/media/foto-ana.ce6fca11.jpg";